// @flow
import reducerChain from '../helpers/chain';
import Constants from '../../constants';
import { parseActionTypeAndState, actionPredicate } from '../helpers';
import type { Action } from '../../actions/types';
import { DeleteConfirmationRecord } from '../../records';

export const DEFAULT_STATE = new DeleteConfirmationRecord();

/**
 * Clear deleteConfirmation entries from state.
 *
 * @param acceptedActions
 */
export const closeDialogReducer =
	(acceptedActions: Array<string>) =>
	(state: DeleteConfirmationRecord = new DeleteConfirmationRecord(), dispatchedAction: Action) => {
		const action = parseActionTypeAndState(dispatchedAction);

		if (actionPredicate(action.actionType, acceptedActions)) {
			return state.clear();
		}

		return state;
	};

/**
 * Add visible flag, contentType, contentId, and parentId into state.
 *
 * @param acceptedActions
 */
export const openDialogReducer =
	(acceptedActions: Array<string>) =>
	(state: DeleteConfirmationRecord = new DeleteConfirmationRecord(), dispatchedAction: Action) => {
		const action = parseActionTypeAndState(dispatchedAction);

		if (actionPredicate(action.actionType, acceptedActions)) {
			return state.withMutations((s) => {
				s.set('visible', true);
				s.set('type', action.params.contentType);
				s.set('id', action.params.id);
				s.set('parentId', action.params.parentId);
				s.set('questionId', action.params.questionId);
			});
		}
		return state;
	};

const closeDialog = closeDialogReducer([Constants.CLOSE_DELETE_DIALOG]);
const openDialog = openDialogReducer([Constants.OPEN_DELETE_DIALOG]);

export default reducerChain([openDialog, closeDialog], DEFAULT_STATE);
